import { DetailsTabMenu } from '@/components/details';
import { bookingDetailsRoute } from '@/features/dashboard/bookingChanges/routes/bookingDetailsRoute.ts';
import { bookingTabLinks } from '@/features/dashboard/bookingChanges/routes/detailsTabs.ts';

/** Goły adres rezerwacji: menu kafli na telefonie, „Rezerwacja” szeroko. */
const BookingTabMenu = () => {
  const { bookingId } = bookingDetailsRoute.useParams();
  const search = bookingDetailsRoute.useSearch();

  return <DetailsTabMenu tabs={bookingTabLinks(bookingId, search)} />;
};

export default BookingTabMenu;
